export const successToast = (toast: any, message: string) => {
  return toast({
    duration: null,
    isClosable: true,
    position: "bottom-left",
    status: "success",
    title: message,
  });
};

export const errorToast = (toast: any, message: string) => {
  return toast({
    duration: null,
    isClosable: true,
    position: "bottom-left",
    status: "error",
    title: message,
  });
};

export const infoToast = (toast: any, message: string) => {
  return toast({
    duration: null,
    isClosable: true,
    position: "bottom-left",
    status: "info",
    title: message,
  });
};
